import FinishStage from 'components/stages/enhancement/FinishStage/FinishStage'

export default FinishStage
